import { titleCase } from "@gigpro/utils";

/** Turn an UPPER_SNAKE enum value or snake_case field name into a human-readable label. */
export const humanize = (value: string) => titleCase(value.replaceAll("_", " ").trim());
